import InputIcon from "@mui/icons-material/Input";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import HeaderReq from "../../../scripts/functions/headerReq";

function FrogetPassword() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState("");
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);

  const clickHandler = () => {
    setLoading(true);
    axiosInstance
      .post(
        API.auth.forgetPassWord,
        {
          ...data,
        },
        HeaderReq()
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoading(false);
        /*    if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          width: "100%",
          height: "100vh",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          overflowX: "hidden",
        }}
        className=" relative bg-white"
      >
        {themeDisplay === "blue" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/2-01.svg"
            alt=""
          />
        ) : themeDisplay === "green" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/3-01.svg"
            alt=""
          />
        ) : themeDisplay === "orange" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/4-01.svg"
            alt=""
          />
        ) : themeDisplay === "dark" ? (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/5-01.svg"
            alt=""
          />
        ) : (
          <img
            className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
            src="/assets/images/login/1-01.svg"
            alt=""
          />
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",

            padding: "12px",
            minWidth: { md: "380px" },
            width: { md: "auto", xs: "95%" },
            mx: "10px",
          }}
          className="relative  z-40 bg-transparent"
        >
          <Box
            sx={{
              px: "15px",
              fontSize: "1.25rem",
              mt: "19.5px",
              fontWeight: "bold",
              textAlign: "center",
            }}
            className="text-white mb-7"
          >
            بازیابی رمز عبور
          </Box>
          <Box
            component={"form"}
            className="loginTab"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: "12px",
              height: "100%",
              gap: 3,
              borderRadius: { md: "4px 0px 0px 4px", xs: "0px 0px 4px 4px" },
            }}
          >
            <div className="flex bg-white w-full rounded-md gap-2 items-center pr-2 pl-1">
              <small className="min-w-max">نام کاربری/کد ملی</small>

              <TextField
                id="outlined-basic"
                variant="outlined"
                fullWidth
                type="text"
                name="user_name"
                onChange={(e) =>
                  setData({ ...data, chUserName: e.target.value })
                }
                value={data?.chUserName || ""}
              />
            </div>
            <div className="flex bg-white w-full rounded-md gap-2 items-center pr-2 pl-1">
              <small className="min-w-max"> تلفن همراه </small>
              <TextField
                id="outlined-basic"
                variant="outlined"
                fullWidth
                type="tel"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*?)\..*/g, "$1");
                }}
                name="user_name"
                error={err}
                helperText={err}
                onChange={(e) => {
                  if (e.target.value.length < 12) {
                    setData({ ...data, chMobile: e.target.value });
                  }
                }}
                value={data?.chMobile || ""}
                inputProps={{ maxLength: 11 }}
                onBlur={(e) => {
                  if (e.target.value.length < 10) {
                    toast.error("تلفن همراه وارد شده معتبر نمی باشد");
                    setError("تلفن همراه وارد شده معتبر نمی باشد");
                  } else {
                    setError("");
                  }
                }}
              />
            </div>
          </Box>
          <Box
            component={"div"}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: "12px",
            }}
            className="loginButton"
          >
            <Link to="/">
              <Button
                variant="contained"
                sx={{
                  fontSize: "1rem",
                  backgroundColor: "#0091ea",
                  width: "150px !important",
                }}
              >
                <InputIcon sx={{ width: "18px", height: "18px", mr: "5px" }} />
                بازگشت
              </Button>
            </Link>{" "}
            <Button
              variant="contained"
              disabled={!data?.chUserName || !data?.chMobile || loading}
              sx={{
                fontSize: "1rem",
                backgroundColor: "#0091ea",
                width: "150px !important",
              }}
              onClick={clickHandler}
            >
              {loading ? (
                <>
                  {" "}
                  <CircularProgress size={27} />
                </>
              ) : (
                <> ارسال رمز عبور</>
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default FrogetPassword;
